<template>
    <div class="content_wrapper">
        <div class="content">
            <div class="main_title">
                <img src="@/assets/icons/bobSepticFinalScreenTitle.svg" alt="">
            </div>
            <div class="finger">
                <img src="@/assets/icons/bs_finger.svg" alt="">
            </div>
            <div class="main_subtitle">
                <img src="@/assets/icons/bobSepticFinalScreenSubtitle.svg" alt="">
            </div>
            <div class="footer_buttons">
                <div class="footer_text">Are you excited?</div>
                <div class="happy_button">
                    <a href="https://my.air-vote.com/r/rate/62482636-bf24-4cc5-93b6-7c49de746c1e/3">
                      <img src="@/assets/icons/bs_happy.svg" alt="">
                    </a>
                </div>
                <div class="sad_button">
                    <a href="https://my.air-vote.com/r/rate/62482636-bf24-4cc5-93b6-7c49de746c1e/1">
                      <img src="@/assets/icons/bs_sad.svg" alt="">
                    </a>
                </div>
            </div>
            <div style="display: inline-block">

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "bobsSepticEventFinalScreen",
    async mounted() {
        document.body.classList.add('bs_body')
    },
    async destroyed() {
        document.body.classList.remove('bs_body')
    },
}
</script>

<style scoped>
    .content_wrapper {
        background-color: #e79922;
    }
    .content {
        padding-left: 25px;
        padding-right: 25px;
    }
    .main_title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 38px 10px 21px;
    }
    .main_subtitle {
        display: flex;
        justify-content: center;
    }
    .main_subtitle img {
        max-width: 250px;
    }
    .finger {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
    }
    .finger img {
        width: 230px;
    }
    .footer_buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        padding-bottom: 22px;
    }
    .footer_text {
        font-family: "Proxima Nova";
        color: white;
        font-size: 22px;
        text-transform: uppercase;
    }
    .happy_button, .sad_button {
        width: 45px;
        margin-left: 10px;
    }
    .main_title img {
        max-width: 100%;
    }
    @media screen and (min-height: 800px) {
        .content_wrapper {
            height: 100vh;
        }
    }
    @media screen and (max-width: 376px) and (max-height: 668px) {
        .footer_text {
            font-size: 20px;
        }
        .finger img {
            width: 180px;
        }
    }
    @media screen and (max-height: 370px ) {
        .footer_text {
            font-size: 18px;
        }
    }
    @media screen and (max-height: 741px) {
        .footer_text {
          font-size: 18px;
        }
    }
    @media screen and (max-width: 321px)  {
        .footer_text {
            font-size: 16px;
        }
    }
</style>